export default __webpack_public_path__ + "static/media/key.a6f935ce.svg";